export interface ParsedOrderIds {
	/** Deduplicated numeric order ids, insertion order preserved. */
	valid: number[];
	/** Tokens matching neither accepted format (deduped) — shown to the operator, never silently dropped. */
	rejected: string[];
	/** Tokens dropped because an earlier token already produced the same id. */
	duplicateCount: number;
}

const NUMERIC_RE = /^\d+$/;
// Display format "DF32-123123" = SellerUniqueId-OrderId -> the digits AFTER the dash are the order id.
const DISPLAY_RE = /^[A-Za-z0-9]+-(\d+)$/;

export const parseOrderIds = (raw: string): ParsedOrderIds => {
	const tokens = raw.split(/[\s,;]+/).filter(Boolean);
	const seen = new Set<number>();
	const rejectedSet = new Set<string>();
	const valid: number[] = [];
	let duplicateCount = 0;

	for (const token of tokens) {
		let idString: string | null = null;
		if (NUMERIC_RE.test(token)) {
			idString = token;
		} else {
			const match = DISPLAY_RE.exec(token);
			if (match) idString = match[1];
		}
		if (idString === null) {
			rejectedSet.add(token);
			continue;
		}
		const id = Number(idString);
		// "0" or absurd lengths are rejected here rather than 400-ing server-side.
		if (!Number.isSafeInteger(id) || id <= 0) {
			rejectedSet.add(token);
			continue;
		}
		if (seen.has(id)) {
			duplicateCount += 1;
			continue;
		}
		seen.add(id);
		valid.push(id);
	}

	return { valid, rejected: Array.from(rejectedSet), duplicateCount };
};
